import { NsColumn } from '@britishgasenergy/react-nucleus';
import type { NsColumnProps } from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn/NsColumn';

import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { AuthProvider } from 'components/common/auth-provider/AuthProvider';
import { RouteScreenContext } from 'components/app/AppContext';

import type { Route } from 'components/app/routes/app-routes-revamp';

type RouteScreenProps = {
  route: Route;
  routes: Route[];
  isLoginEnabled?: boolean;
};

export const RouteScreen = (props: RouteScreenProps) => {
  const { route, routes, isLoginEnabled } = props;
  const {
    Content,
    LeftSidebar,
    RightSidebar,
    Header,
    Footer,
    requiresLogin,
    noIndex
  } = route;
  const routeScreenContextValue = { route, routes };
  const authEnabled = requiresLogin && isLoginEnabled;
  const hasRightSidebar = !!RightSidebar;
  const hasLeftSidebar = !!LeftSidebar;
  let col: NsColumnProps['hockeypitch'] = '1';

  switch (true) {
    case hasLeftSidebar && !hasRightSidebar:
      col = '1:2';
      break;
    case !hasLeftSidebar && hasRightSidebar:
      col = '2:1';
      break;
    default:
      col = '1';
  }

  return (
    <>
      {noIndex && <meta name="robots" content="noindex" />}

      <AuthProvider enabled={authEnabled}>
        <RouteScreenContext.Provider value={routeScreenContextValue}>
          <main id="#content">
            <NsPanel decoration="cyan-light">
              {Header && <Header />}

              <NsColumn hockeypitch={col}>
                {hasLeftSidebar && <LeftSidebar />}
                {Content && <Content />}
                {hasRightSidebar && <RightSidebar />}
              </NsColumn>
            </NsPanel>

            {Footer && <Footer />}
          </main>
        </RouteScreenContext.Provider>
      </AuthProvider>
    </>
  );
};
